import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { Reclamation } from '../models/reclamation';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class ReclamationService {
  private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt']+'/reclamations/';
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  }
  reclamationsportbanque: Reclamation[]=[];
  reclamationscomm: Reclamation[]=[];

    
    constructor(private http: HttpClient) { }
    public allreclamations: Reclamation[] = [];

    public reclamations: Reclamation[] = [];
    public reclamationsacq: Reclamation[] = [];
    public reclamationseme: Reclamation[] = [];
    public reclamationsonus: Reclamation[] = [];
    public allreclamations$ = new Subject<Reclamation[]>();

    public reclamations$ = new Subject<Reclamation[]>();
    public reclamationsportbanque$ = new Subject<Reclamation[]>();
    public reclamationscomm$ = new Subject<Reclamation[]>();

    public reclamationsacq$ = new Subject<Reclamation[]>();
    public reclamationseme$ = new Subject<Reclamation[]>();
    public reclamationsonus$ = new Subject<Reclamation[]>();

   /* public changements$ = new Subject<Reclamation["changements"]>();
    public changements: Reclamation["changements"];*/
    public statuts$ = new Subject<Reclamation["statut"]>();
    public statuts: Reclamation["statut"];
    getReclamations() {
      const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}`).subscribe(
          (reclamations: Reclamation[]) => {
            if (reclamations) {
              this.allreclamations = reclamations;
              this.emitReclamationsall();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
      emitReclamationsall() {
        this.allreclamations$.next(this.allreclamations);
      }
      emitReclamations() {
        this.reclamations$.next(this.reclamations);
      }
      emitReclamationsacq() {
        this.reclamationsacq$.next(this.reclamationsacq);
      }
      emitReclamationseme() {
        this.reclamationseme$.next(this.reclamationseme);
      }
      emitReclamationsonus() {
        this.reclamationsonus$.next(this.reclamationsonus);
      }
      emitReclamationsportbanque() {
        this.reclamationsportbanque$.next(this.reclamationsportbanque);
      }
      emitReclamationscomm() {
        this.reclamationscomm$.next(this.reclamationscomm);
      }
      getReclamationdataById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
            this.http.get(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }
   /*   emitchangements() {
        this.changements$.next(this.changements);
      }*/
      emitstatuts() {
        this.statuts$.next(this.statuts);
      }
      getReclamationdataByIdsubscription(id: string) {
        const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}${id}`).subscribe(
          (reclamation: Reclamation) => {
           /* if (reclamation.changements) {
              this.changements = reclamation.changements;
              this.emitchangements();
            }*/
            if (reclamation.statut) {
              this.statuts = reclamation.statut;
              this.emitstatuts();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
      getReclamationacq(banque: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/acquireur/${banque}`).subscribe(
          (response: Reclamation[]) => {
            if (response) {
              this.reclamationsacq=response
              this.emitReclamationsacq()
            }
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationeme(banque: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/emetteur/${banque}`).subscribe(
          (response: Reclamation[]) => {
            if (response) {
              this.reclamationseme=response
              this.emitReclamationseme()
            }
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationonus(banque: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/onus/${banque}`).subscribe(
          (response: Reclamation[]) => {
            if (response) {
              this.reclamationsonus=response
              this.emitReclamationsonus()
            }
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationactif(banque:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/filter/recs/actif/${banque}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationcloture(banque:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/filter/recs/cloture/${banque}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationtotreat(banque:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/totreat/${banque}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationcomitetotreat(banque:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/totreat/comite/${banque}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationporteurtotreat(carte:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/totreat/porteur/${carte}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamationallperbanque(banque:string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/filter/recs/total/${banque}`).subscribe(
          (response: any) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      getReclamation(userId: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}/reclamation/`,{userId}).subscribe(
            (reclamations: Reclamation[]) => {
              if (reclamations) {
                this.reclamations = reclamations;
                this.emitReclamations();
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
      getReclamationportbanque(carte:any) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}/multiuserrec/`,{carte}).subscribe(
            (reclamations: Reclamation[]) => {
              if (reclamations) {
                this.reclamationsportbanque = reclamations;
                this.emitReclamationsportbanque();
              }
            },
            (error) => {
              console.log(error);
            }
          );
        });
      }
      getReclamationcomm(idlist: any) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}/commercant/`,{idlist}).subscribe(
          (response: Reclamation[]) => {
            if (response) {
              this.reclamationscomm=response
              this.emitReclamationscomm()
            }
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });
      }
      create(Reclamation: Reclamation, image: File| string) {
        return new Promise((resolve, reject) => {
          let Reclamationdata: Reclamation | FormData;
          if (typeof image === 'string') {
            console.log(image)
            Reclamationdata = Reclamation;
          } else {
            Reclamationdata = new FormData();
            Reclamationdata.append('reclamation', JSON.stringify(Reclamation));
            Reclamationdata.append('image', image, Reclamation._id);
          }
          const baseUrl = this.getBaseUrl();
          this.http.post(`${baseUrl}`, Reclamationdata).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        }); 
      }
      modify(id: string, Reclamation: Reclamation, uploadedfiles: File[]) {
        return new Promise((resolve, reject) => {     
          let  Reclamationdata = new FormData();
            Reclamationdata.append('reclamation', JSON.stringify(Reclamation));
            
    for (var i = 0; i < uploadedfiles.length; i++) { 
                  //@ts-ignore
      Reclamationdata.append('image', uploadedfiles[i], i+Reclamation.statut[Reclamation.statut.length-1].date+Reclamation._id);
    }
    const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}${id}`, Reclamationdata).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
      savereclamationById(id: string, reclamation: Reclamation) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}modify/${id}`, reclamation).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
      deleteReclamationdataById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
    }
